/* eslint-disable */
/* tslint:disable */

import { CommissionRoleResponse } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

class CommissionRoles<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Комиссии
	 * @summary Получение возможных ролей членов комиссии
	 * @request GET:/commission_roles/list
	 * @secure
	 */
	listList = (params: RequestParams = {}) =>
		this.request<CommissionRoleResponse[], void>({
			path: `/commission_roles/list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
}
export const commissionRolesAPI = new CommissionRoles();
